import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
  },
  tableBox: {
    margin: theme.spacing(2, 0, 0),
    [theme.breakpoints.down('sm')]: {
      marginTop: '35px',
    },
  },
  infoContainer: {
    display: 'flex',
    height: 50,
  },
  title: {
    flexGrow: 1,
    margin: theme.spacing(1),
  },
  sync: {
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
    flexGrow: 1,
    margin: theme.spacing(1),
    color: 'red',
  },
  paper: {
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
    flexDirection: 'column',
    boxShadow: theme.shadows[0],
  },
}));
